import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';

export interface FooterCSSStyle extends UIComponentCSSStyle
{
    getNavBlockMainWrapperCSSStyle():object; 
    getNavBlockWrapperCSSStyle():object; 
    getNavBlockWrapper2CSSStyle():object;
    getLineCSSStyle():object;
    getCopyrightWrapperCSSStyle():object;
    getCopyrightTextCSSStyle():object;
}

export class FooterCSSStyleImpl extends UIComponentCSSStyleImpl implements FooterCSSStyle
{
    getNavBlockMainWrapperCSSStyle(): object {
        return {    
                    display: 'flex', 
                    flexWrap: 'wrap'
                };
    }

    getNavBlockWrapperCSSStyle(): object {
        return {    
                    width: '180px',
                    marginRight:'110px'
                };
    }
    getNavBlockWrapper2CSSStyle(): object {
        return {    
                    width: '240px',
                    marginRight:'110px'

                };
    }
    getWrapperCSSStyle(): object{
        return {
                    backgroundColor: this.getResources().getColor(Colors.color_4),
                };
    }

    getLineCSSStyle(): object {
        return {
                height: '2px', 
                backgroundColor: this.getResources().getColor(Colors.color_5), 
                marginLeft: '10px', 
                marginRight: '10px', 
                marginTop: '30px'
            };
    }

    getCopyrightWrapperCSSStyle(): object {
        return {
                display: 'flex', 
            };
    }

    getCopyrightTextCSSStyle(): object {
        return {
                width: '100%',
                fontFamily: this.getResources().getFontFamily(), 
                fontSize: this.getResources().getFont(Fonts.h5), 
                color: this.getResources().getColor(Colors.color_5), 
                padding: '10px',
                // justifyContent: 'flex-start'
                textAlign:'left'
            };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/footercss.tsx